// Check docs: src/scss/_mixins.scss
const gap = 64

export const breakpoints = {
  tablet: 768,
  desktop: 960 + 2 * gap,
  widescreen: 1152 + 2 * gap,
  fullhd: 1344 + 2 * gap
}
